import { Flex } from '@chakra-ui/react'
import { Text } from 'components'
import { useBreakpoint } from 'utils'
import { ManageMedia } from '../media'

export default function ManageMediaPage() {
  const isMobile = useBreakpoint() < 2

  return (
    <Flex
      direction="column"
      gap={4}
      flex="auto"
      pb={3}
      px={isMobile ? 2 : 0}
      pr={5}
      overflowY="auto"
      overflowX="hidden"
    >
      <Text textStyle="h3" pt={2}>
        Media Content
      </Text>
      <ManageMedia />
    </Flex>
  )
}
